import { Column, StatProps, StatColumn, TextVariant } from "@bridgesplit/ui";
import { Divider } from "@mui/material";

export default function OracleTooltipTitle({
    topLevelOracleStats,
    customOracleStats,
    variant
}: {
    topLevelOracleStats: StatProps[] | undefined;
    customOracleStats: StatProps[] | undefined;
    variant: TextVariant;
}) {
    return (
        <Column spacing={1.5} padding={1}>
            <StatColumn stats={topLevelOracleStats} variant={variant} />
            {customOracleStats && customOracleStats.length > 0 && (
                <>
                    <Divider />
                    <StatColumn stats={customOracleStats} variant={variant} />
                </>
            )}
        </Column>
    );
}
